import { DynamicUGOHub } from './DynamicUGOHub';
import { DynamicMapStoreBase } from '../DynamicMapStoreBase';
import { DynamicProfileLayerType, ProfileKeyCode } from '../DynamicProfileEnums';


class DynamicUGOMapStore extends DynamicMapStoreBase {
  protected hub: DynamicUGOHub;
  
  /**
   *
   */
  constructor(hub: DynamicUGOHub) {
    super();

    this.hub = hub;
    this.profileKeys = [ProfileKeyCode.TGS, ProfileKeyCode.REACH];
  }

  /** abstract method implementation */
  setAlignment(data: any) { }
  clearAlignment() { }
  setTracker(d: number, y: number) { }
  clearTracker() { }
  addStations() { }
  clearReachStations() { }
  moreSketchVmSetup() { }
  SketchPolyline() { }
  toggleAlignmentSnapping() { }
  SketchPoint() { }
  ReshapePolyline() { }
  LoadEditToMap(data: any, keyCode: ProfileKeyCode) { }
  drawCurve(curveData: any) { }
  removeMapLayer(layer: DynamicProfileLayerType) { }
  configSketchVM() { }
  updateAlignmentOnMap(data: any, keyCode: ProfileKeyCode) { }
  checkToConvertAlignment(index) { }
  redrawAlignmentProfile() { } // Only used for alignment
  generateAlignmentLabelsLayer() { }
  handlePolylineCreateEvent(event: __esri.SketchViewModelCreateEvent): Promise<void> {
    return this.emptyPromiseVoid;
  }
  handlePointCreateEvent(event: __esri.SketchViewModelCreateEvent): Promise<void> {
    return this.emptyPromiseVoid;
  }
  handleReshapeEvent(event: __esri.SketchViewModelUpdateEvent): Promise<void> {
    return this.emptyPromiseVoid;
  }
  /** end of abstract method implementation */


  Dispose() {
    super.Dispose();
  }
}

export { DynamicUGOMapStore };
